import { render, staticRenderFns } from "./JobDeviceDetailsCard.vue?vue&type=template&id=67e357a1&"
import script from "./JobDeviceDetailsCard.vue?vue&type=script&lang=js&"
export * from "./JobDeviceDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports